import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { actions as recoveryPasswordActions } from "reducers/recoveryPassword";
import { actions as loginActions } from "reducers/login";

import Notification from "pages/_components/Notification";
import Step2Content from "pages/recoveryPassword/_components/Step2Content";
import MainContainer from "pages/_components/MainContainer";
import withExchangeToken from "pages/_components/withExchangeToken";
import LogoTitle from "pages/login/_components/LogoTitle";
import Head from "pages/_components/Head";
import { goBack } from "connected-react-router";

class RecoveryPassStep2 extends Component {
    componentWillUnmount() {
        this.props.dispatch(recoveryPasswordActions.recoveryPassCleanUp());
    }

    onHeaderClose = () => {
        this.props.dispatch(loginActions.reset());
    };

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    render() {
        const { isDesktop } = this.props;
        const mainContainerClass = classNames({
            "main-container": true,
            "container-fluid": this.props.isDesktop,
        });

        return (
            <React.Fragment>
                <Head
                    title=""
                    styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                    onBack={this.onHeaderBack}
                    hideNavbarInMobile
                />
                {!isDesktop && <LogoTitle />}
                <Notification scopeToShow="recoveryPassword" />
                <MainContainer className={mainContainerClass}>
                    <Step2Content {...this.props} />
                </MainContainer>
            </React.Fragment>
        );
    }
}

export default connect(null)(withExchangeToken(RecoveryPassStep2));
